module.exports = __webpack_public_path__ + "static/img/GM.c9f4f3ea.svg";